import { axiosPatientInstance } from "config";
import { useAxiosQuery } from "hooks";

function useGetCurrentSummaryFile(
  encounterId: string,
  options?: { enabled: boolean }
) {
  return useAxiosQuery(
    ["currentSummaryFile", { encounterId }],
    () =>
      axiosPatientInstance.get<Blob>(`v1/summary/${encounterId}/current`, {
        responseType: "blob",
      }),
    { ...options }
  );
}

export { useGetCurrentSummaryFile };
